import React from "react";

function ShowMoreModal({ submission, setShowMoreModal }) {

  // Filter out the show_on_slack property from submission
  const filteredSubmission = Object.keys(submission).reduce((obj, key) => {
    if (key !== 'show_on_slack') {
      obj[key] = submission[key];
    }
    return obj;
  }, {});
  
  return (
    <div
      className="fixed z-10 inset-0 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          aria-hidden="true"
        ></div>

        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>

        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start mb-3">
              <h3
                className="text-lg leading-6 font-medium text-gray-900"
                id="modal-headline"
              >
                All details
              </h3>
            </div>

            <div className="space-y-4">
              {Object.entries(filteredSubmission).map(([key, value]) => (
                <div key={key}>
                  <h4 className="text-gray-500">{key}</h4>
                  <p>{typeof value === "boolean" 
                      ? (key === "isOnCopper" && value === true) 
                        ? "This lead already exists in Copper" 
                        : value.toString() 
                      : key === "submitted_at" 
                        ? new Date(value).toLocaleString("en-GB") 
                        : value}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse">
            <button
              type="button"
              onClick={() => setShowMoreModal(false)}
              className="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShowMoreModal;
